import {
    SquareCode,
} from "lucide-react";

export const lessons = [
  {
    id: 1,
    title: 'Урок 1',
    href: '0000-1111-1111',
    description: 'Навчитись писати прості програми. Перевірити налаштування середовища програмування',
    date: 'Apr 23, 2025',
    datetime: '2025-04-23',
    icon: SquareCode,
  }
];
